import { AddressStreetType, FilePayload, NewPasswordType, TempDeleteInfoObjectType } from "./common.types";
import { PhoneType } from "./customer-form.types";

// CREATE DRIVER
interface DriverInfoFormType extends AddressStreetType, NewPasswordType {
    fullName: string;
    identityType: "NRIC" | "PASSPORT";
    passportID: string;
    mobileNo: PhoneType;
    emailAddress: string;
    gender: string;
};

interface VehicleInfoFormType {
    // orgType: OrgType;
    parentOrgID: string; // value of the chosen company
    doesRiderOwnVehicle: "true" | "false";
    vehicleCategory: "ELECTRIC" | "NORMAL";
    vehicleType: "CAR" | "VAN" | "MOTORCYCLE" | "LORRY";
    vehicleModel: string;
    plateNumber: string;
};

interface PaymentDetailsFormType {
    accountNo: string;
    bankType: string;
    socsoNo: string;
    epfNo: string;
    incomeTax: string;
    hrdfNo: string;
    zakatNo: string;
};

interface EmergencyContactsFormType {
    relationship: string;
    emergencyContactName: string;
    emergencyContactNo: PhoneType;
};

interface AttachmentsFormType {
    file?:FilePayload;
    nric_passport:FilePayload;
    driving_license:FilePayload;
    road_tax:FilePayload;
    photo_of_vehicle:FilePayload;
    acceptTerms: boolean;
}

export interface DriverCreationFormType extends DriverInfoFormType, VehicleInfoFormType, PaymentDetailsFormType, EmergencyContactsFormType, AttachmentsFormType{
    _id?: string;
    // profileID?:string;
    code?:string;
    riderType?:string;
    // approvalStatus?:string;
    // rejectedReason?:string,
}

// MISC
export type RiderType = "EXTERNAL" | "INTERNAL";

export enum DriverCategoriesTabs {
    DRIVER_INFO = "driver_details",
    VEHICLE_INFO = "vehicle_information",
    PAYMENT_INFO = "payment_details",
    EMERGENCY_INFO = "emergency_contact_details",
    ATTACHMENT_INFO = "attachments",
}

export type DriverCategories = [
    DriverCategoriesTabs.DRIVER_INFO,
    DriverCategoriesTabs.VEHICLE_INFO,
    DriverCategoriesTabs.PAYMENT_INFO,
    DriverCategoriesTabs.EMERGENCY_INFO,
    DriverCategoriesTabs.ATTACHMENT_INFO,
]

export enum DriverApprovalStatus {
    PENDING = "PENDING",
    APPROVED = 'APPROVED',
    UNAPPROVED = 'UNAPPROVED',
    REJECTED = 'REJECTED',
}

export enum DriverStatus {
    ACTIVATE = "ACTIVATE",
    DEACTIVATE = "DEACTIVATE",
}

export enum SortingMode {
    ASC = "ASC",
    DESC = "DESC",
    NEITHER = ""
}

export interface Sorting {
    sortBy: string;
    mode: SortingMode;
}